import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

// namespace SlotGames
// {

	export class MysticKingdomFillingPot_2Screen extends SlotGameType1_2Screen {

        // protected override panelFactory:IPanelFactory = new MysticKingdomFillingPotPanelFactory();
		protected override helpFactory:IHelpFactory = new MysticKingdomFillingPotHelpFactory();
        

        
        //LED COLOR
		protected override ColorLed:string="255,255,0\n";
        protected override panelColor: ButtonColors={
			backgroundButtonColor: "linear-gradient(rgb(52, 2, 56),rgb(89, 4, 97), rgb(122, 5, 133),rgb(89, 4, 97),rgb(52, 2, 56)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, rgb(217, 145, 11),transparent ) 0 10 100%",
		};
		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "MysticKingdomFillingPot");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		
        }
        
        //SEND COLOR FOR SRA
    protected override color: RewardColor =
    {
        color: "#F9F8E2",
        coloroutherStroke: "#013809",
        colorinnerStroke: "#0EE104"
    }

		
    }
    

	


//Panel Colorized merged
class MysticKingdomFillingPotPanelFactory implements IPanelFactory
{
    public CreateNewPanel(params: PanelParams):Panel
    {
        return new MysticKingdomFillingPotPanel(params);
    }
}

class MysticKingdomFillingPotPanel extends Panel
{
    protected override ButtonBackground():ButtonColors
    {
        let color:ButtonColors ={
            backgroundButtonColor: "linear-gradient(rgb(52, 2, 56),rgb(89, 4, 97), rgb(122, 5, 133),rgb(89, 4, 97),rgb(52, 2, 56)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor:"linear-gradient(to left , transparent, chartreuse,transparent ) 0 10 100%",
        };
        
        return color;
    }

}

class MysticKingdomFillingPotHelpFactory implements IHelpFactory
{
    public CreateNewHelp(params: HelpParameters):Help
    {
        return new   MysticKingdomFillingPotHelp(params);
    }
}

class MysticKingdomFillingPotHelp extends Help
{
    protected override BackgroundPanel():HelpPanelColor
    {
        let color:HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(52, 2, 56),rgb(89, 4, 97), rgb(122, 5, 133),rgb(89, 4, 97),rgb(52, 2, 56)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
